<template>
  <div class="container">

    <heading-one class="-margin-md">口座のご登録</heading-one>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="2" type="entry"></main-wizard>
    </wizard-group>

    <template v-if="state === '0'">
      <card-box>
        <card-header class="account-header">
          <div class="flex account-ttl">
            <h2 class="_mr-10 _mr-md-20 heading account-heading">口座のご登録について</h2>
            <div class="account-labels">
              <span class="account-label">審査最短即日</span>
              <span class="account-label">郵送物無し</span>
            </div>
          </div>
        </card-header>
        <p class="account-info">本手続きで口座の登録と合わせてご本人さま確認とさせていただくため、ご本人さま確認書類のご提出は不要で、郵送物もございません。</p>
        <card-body>
          <list-group class="-normal">
            <list-item class="-normal">お借り入れ・ご返済にご利用いただく、お客さまの金融機関口座をご登録いただきます。</list-item>
            <list-item class="-normal">ご登録には金融機関の支店名・預金種別・口座番号などの入力が必要となります。通帳やキャッシュカードなどをお手元にご用意ください。</list-item>
            <list-item class="-normal">ご登録いただけるのはご本人さま名義の口座に限ります。各金融機関さまのご登録完了と同時にご本人さま確認とさせていただきます。</list-item>
          </list-group>
          <btngroup-single class="account-btn">
            <btn-main class="-main-out" @click.prevent="showModal">
              口座のご登録を行う
            </btn-main>
          </btngroup-single>
          <small class="account-note">※ご登録可能な金融機関については口座のご登録にお進みいただき、次画面にてご確認下さい。</small>
        </card-body>
      </card-box>
      <p class="account-bottom">※口座のご登録が出来ないお客さまや口座をお持ちで無いお客さまはこちら</p>
      <p>ご本人さま確認書類の提出が必要となり、<span class="underline">ご契約までのお手続きに約１週間程度お時間がかかります</span>ので、あらかじめご了承ください。</p>
      <list-group class="-link _mb-md-60 _mb-sm-4 0">
        <list-item class="-link" routerName="en007">ご本人さま確認書類のご提出を行う</list-item>
      </list-group>
    </template>

    <template v-if="state === '1'">
      <notice-box class="-alert _mb-sm-30 _mb-md-50">
        <notice-header>
          <h2 class="heading">口座のご登録が完了しておりません。</h2>
        </notice-header>
        <notice-body>
          ご登録を完了するには、以下のお手続きを行ってください。
        </notice-body>
      </notice-box>
      <card-box>
        <card-header class="account-header">
          <div class="flex account-ttl">
            <h2 class="_mr-5 _mr-md-10 heading account-heading">口座のご登録について</h2>
            <div class="account-labels">
              <span class="account-label">審査最短即日</span>
              <span class="account-label">郵送物無し</span>
            </div>
          </div>
        </card-header>
        <p class="account-info">本手続きで口座の登録と合わせてご本人さま確認とさせていただくため、ご本人さま確認書類のご提出は不要で、郵便物もございません。</p>
        <card-body>
          <list-group class="-normal">
            <list-item class="-normal">お借り入れ・ご返済にご利用いただく、お客さまの金融機関口座をご登録いただきます。</list-item>
            <list-item class="-normal">ご登録には金融機関の支店名・預金種別・口座番号などの入力が必要となります。通帳やキャッシュカードなどをお手元にご用意ください。</list-item>
            <list-item class="-normal">ご登録いただけるのはご本人さま名義の口座に限ります。各金融機関さまのご登録完了と同時にご本人さま確認とさせていただきます。</list-item>
          </list-group>
          <btngroup-single class="account-btn">
            <btn-main class="-main-out" @click.prevent="showModal">
              口座のご登録を行う
            </btn-main>
          </btngroup-single>
          <small class="account-note">※ご登録可能な金融機関については口座のご登録にお進みいただき、次画面にてご確認下さい。</small>
        </card-body>
      </card-box>
      <p class="account-bottom">※口座のご登録が出来ないお客さまや口座をお持ちで無いお客さまはこちら</p>
      <p>ご本人さま確認書類の提出が必要となり、<span class="underline">ご契約までのお手続きに約１週間程度お時間がかかります</span>ので、あらかじめご了承ください。</p>
      <list-group class="-link _mb-md-60 _mb-sm-4 0">
        <list-item class="-link" routerName="en007">ご本人さま確認書類のご提出を行う</list-item>
      </list-group>
    </template>

    <template v-else-if="state === '2'">
      <notice-box class="-alert _mb-sm-30 _mb-md-50">
        <notice-header>
          <h2 class="heading">口座のご登録ができませんでした。</h2>
        </notice-header>
        <notice-body>
          改めて別の口座をご登録いただくか、ページ下部の「ご本人さま確認書類のご提出を行う」よりお手続きください。
        </notice-body>
      </notice-box>
      <card-box>
        <card-header class="account-header">
          <div class="flex account-ttl">
            <h2 class="_mr-5 _mr-md-10 heading account-heading">口座のご登録について</h2>
            <div class="account-labels">
              <span class="account-label">審査最短即日</span>
              <span class="account-label">郵送物無し</span>
            </div>
          </div>
        </card-header>
        <p class="account-info">本手続きで口座の登録と合わせてご本人さま確認とさせていただくため、ご本人さま確認書類のご提出は不要で、郵便物もございません。</p>
        <card-body>
          <list-group class="-normal">
            <list-item class="-normal">お借り入れ・ご返済にご利用いただく、お客さまの金融機関口座をご登録いただきます。</list-item>
            <list-item class="-normal">ご登録には金融機関の支店名・預金種別・口座番号などの入力が必要となります。通帳やキャッシュカードなどをお手元にご用意ください。</list-item>
            <list-item class="-normal">ご登録いただけるのはご本人さま名義の口座に限ります。各金融機関さまのご登録完了と同時にご本人さま確認とさせていただきます。</list-item>
          </list-group>
          <btngroup-single class="account-btn">
            <btn-main class="-main-out" @click.prevent="showModal">
              口座のご登録を行う
            </btn-main>
          </btngroup-single>
          <small class="account-note">※ご登録可能な金融機関については口座のご登録にお進みいただき、次画面にてご確認下さい。</small>
        </card-body>
      </card-box>
      <p class="account-bottom">※口座のご登録が出来ないお客さまや口座をお持ちで無いお客さまはこちら</p>
      <p>ご本人さま確認書類の提出が必要となり、<span class="underline">ご契約までのお手続きに約１週間程度お時間がかかります</span>ので、あらかじめご了承ください。</p>
      <list-group class="-link _mb-md-60 _mb-sm-4 0">
        <list-item class="-link" routerName="en007">ご本人さま確認書類のご提出を行う</list-item>
      </list-group>
    </template>

    <modal-window v-if="isShowModal" @close="hideModal">
      <div>
        <p>口座のご登録が完了していないお客さまは「口座の登録へ戻る」を押して、改めて口座のご登録をお願いします。</p>
        <p>インターネットで口座のご登録が完了したお客さまはブラウザを閉じてください。</p>
        <p>ご登録いただいたメールアドレスに【入会受付完了のお知らせ】をお送りしておりますのでご確認ください。</p>
        <btngroup-single>
          <btn-back class="-back -md" @click.prevent="hideModal">口座の登録へ戻る</btn-back>
        </btngroup-single>
      </div>
    </modal-window>

  </div>
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import NoticeBody from '../components/box/NoticeBody'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import BadgeIcon from '../components/badges/BadgeIcon'
import CardBody from '../components/card/CardBody'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ModalWindow from '../components/modal/ModalWindow'
import BtnClose from '../components/button/BtnClose'
import BtnBack from '../components/button/BtnBack'
import BtnText from '../components/button/BtnText'
export default {
  name: 'En-006',
  metaInfo: {
    title: '口座のご登録',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録'}
    ]
  },
  components: {
    BtnText,
    BtnBack,
    BtnClose,
    ModalWindow,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    CardBody,
    BadgeIcon,
    CardHeader,
    CardBox,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  data () {
    return {
      isShowModal: false,
      isDisabled: false,
      state: this.$route.query.state,
      userData: {
        examination_status: ''
      }
    }
  },
  methods: {
    reload () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        initCredentials().then(res => {
          getUserDataLambdaInvoke().then(res => {
            for (let key in res) {
              if (this.userData.hasOwnProperty(key)) {
                this.userData[key] = res[key]
              }
            }
            let routeData = {}
            if (this.$route.query.state) {
              routeData = this.$router.resolve({name: 'en006', query: {state: this.$route.query.state}})
            } else {
              routeData = this.$router.resolve({name: 'en006'})
            }
            window.open(routeData.href, '_self')
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    showModal () {
      window.open('/koufuri_request_entry.html', '_blank')
      this.isShowModal = true
    },
    hideModal () {
      this.isShowModal = false
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
        if (this.$route.query.state) {
          this.state = this.$route.query.state
        } else {
          // 離脱者用：未入会者※EN004まで入力済EN006まで遷移済
          this.state = '1'
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";

.fontlarge {
  font-size: 17px;
  font-weight: bold;
}

.card-header.account-header {
  @include mq-down(md) {
    padding-right: 0;
    padding-bottom: 13px;
  }
}

.account-info {
  color: $danger;
  margin-bottom: 0;
  @include mq-down(md) {
    padding-left: 18px;
    padding-right: 18px;
  }
  @include mq-up(md) {
    padding-left: 25px;
    padding-right: 25px;
  }
}

.card-header > .flex.account-ttl {
  flex-wrap: wrap;
}

.account-heading {
  white-space: nowrap;
  @include mq-down(md) {
    margin-bottom: 5px;
  }
}

.account-labels {
  display: flex;
  @include mq-down(md) {
    margin-right: 7px;
    margin-bottom: 5px;
  }
}

.account-label {
  display: block;
  background-color: $danger;
  color: $white;
  font-weight: normal;
  text-align: center;
  @include mq-down(md) {
    width: 70px;
    margin-right: 5px;
    font-size: 10px;
    line-height: 18px;
  }
  @include mq-up(md) {
    width: 100px;
    margin-right: 10px;
    font-size: 14px;
    line-height: 24px;
  }
}

.account-btn {
  @include mq-down(md) {
    margin-top: 18px;
    padding-left: 4px;
    padding-right: 4px;
  }
  @include mq-up(md) {
    margin-top: 53px;
  }
}

.account-note {
  display: block;
  text-indent: -0.5em;
  padding-left: 0.5em;
  margin-bottom: 0;
  @include mq-down(md) {
    margin-top: 7px;
  }
  @include mq-up(md) {
    margin-top: 27px;
  }
}

.account-bottom {
  margin-bottom: 0;
  text-indent: -0.5em;
  padding-left: 0.5em;
  @include mq-down(md) {
    margin-top: 58px;
  }
  @include mq-up(md) {
    margin-top: 33px;
  }
}

.underline {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/En006.vue